import Toggle, { ToggleProps } from './Toggle';

export type { ToggleProps };
export default Toggle;
